import { useContext } from "react";

import { TciSessionContext } from "@/providers/tci-session-context";

export function useTciSession() {
  const context = useContext(TciSessionContext);
  if (!context) {
    throw new Error("useTciSession must be used within TciSessionProvider");
  }
  return context;
}
